<template>
  <section ref="root" class="dc-container">
    <!-- papel rasgado -->
    <div class="rasgado rasgado-top"></div>

    <!-- CONTENIDO -->
    <div class="dc-card">
      <!-- Título en dos líneas -->
      <h2 ref="title" class="dc-title">
        <span>Código</span><br />
        <span class="script">de Vestimenta</span>
      </h2>

      <!-- Etiqueta -->
      <div ref="badge" class="dc-badge">FORMAL  </div>

      <!-- Ilustración vestido / traje -->
      <img
        ref="figure"
        src="@/assets/codigo.png"
        alt="Código de vestimenta"
        class="dc-figure"
      />

      <!-- Nota -->
      <p ref="note" class="dc-note">
        Reservamos el color Baby Blue para la Quinceañera <br>
      </p>
    </div>

    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)

    let stInstance = null

    onMounted(async () => {
      await nextTick()

      if (!root.value) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%',
          once: true
        }
      })

      if (title.value) {
        tl.from(title.value, {
          opacity: 0,
          y: -24,
          filter: 'blur(6px)',
          duration: 0.5,
          ease: 'power3.out'
        })
      }

      if (badge.value) {
        tl.from(
          badge.value,
          {
            opacity: 0,
            y: -16,
            scale: 0.98,
            duration: 0.45,
            ease: 'back.out(1.6)'
          },
          '>-0.1'
        )
      }

      if (figure.value) {
        tl.from(
          figure.value,
          {
            opacity: 0,
            scale: 0.9,
            duration: 0.5,
            ease: 'power2.out'
          },
          '>-0.05'
        )
      }

      if (note.value) {
        tl.from(
          note.value,
          {
            opacity: 0,
            y: 14,
            duration: 0.4,
            ease: 'power2.out'
          },
          '>-0.05'
        )
      }
    })

    onUnmounted(() => {
      if (stInstance) stInstance.kill()
      ScrollTrigger.refresh()
    })

    return { root, title, badge, figure, note }
  }
}
</script>

<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background: #8fbbdf;
  padding: 34px 18px 42px;
  overflow: hidden;
  text-align: center;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #8fbbdf;
  z-index: 1;
  pointer-events: none;
}
.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}
.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.dc-card {
  position: relative;
  z-index: 2;
}

.dc-title {
  font-family: 'britishgruesa', cursive;
  font-size: 66px;
  color: #ffffff;
  margin: 0 0 16px;
  line-height: 1.05;
}
.dc-title .script {
  font-weight: 400;
  opacity: 0.9;
}

.dc-badge {
  display: inline-block;
  background: #ffffff;
  color: #333;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 12px;
  letter-spacing: 0.14em;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin: 4px 0 12px;
}

.dc-figure {
  width: 180px;
  height: auto;
  display: block;
  margin: 10px auto 12px;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.15));
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 16px;
  color: #ffffff;
  opacity: 0.9;
  font-style: italic;
  margin: 10px auto 18px;
}
</style>
